import { NgModule } from '@angular/core';
import { FooterComponent } from './components/main/footer.component';

@NgModule({
  declarations: [
    FooterComponent
  ],
  exports: [
    FooterComponent
  ]
})
export class AppFooterModule { }
